export default __webpack_public_path__ + "static/media/08.cc082a77.jpg";